import D3Throttle from '@utilities/throttle';

export default class GoToTopPlugin {
  scrollThrottle: D3Throttle;
  button: HTMLElement;

  constructor(e: HTMLElement) {
    this.button = e;
  }

  init() {
    this.button.onclick = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    this.scrollThrottle = new D3Throttle(window, this.checkScroll, 500, ['scroll.gototop', 'resize.gototop'], this);
    this.scrollThrottle.run();
  }

  detach() {
    this.scrollThrottle?.off();
  }

  get scrollY() {
    return (
      window.scrollY ??
      (document.documentElement || (document.body.parentNode as HTMLElement) || document.body).scrollTop
    );
  }

  checkScroll() {
    this.button.classList.toggle('hidden', this.scrollY < window.innerHeight);
  }
}
